import React from 'react'

import Markdown from '@components/markdown'
import { withLazyRef } from '@util/lazy_ref'

import RocketSingle from '@components/icons/animated/rocket-single'
import Star0 from '@components/icons/star0'
import Star1 from '@components/icons/star1'
import Star2 from '@components/icons/star2'
import Star3 from '@components/icons/star3'
import Star4 from '@components/icons/star4'

class TextBlock extends React.Component {
  getPageBackgroundColor = () => {
    return 'white'
  }

  renderRocket() {
    return (
      <>
        <RocketSingle />
        <Star0 />
        <Star1 />
        <Star2 />
        <Star3 />
        <Star4 />
      </>
    )
  }

  render() {
    const fields = this.props.fields
    const classes = ['textBlock']

    let hasRocket
    if (fields.style === 'Rocket') {
      classes.push('textBlock--' + fields.style.replace(/[\s,&*]/g, ''))
      hasRocket = true
    }

    const body = fields.body

    return (
      <div className={classes.join(' ')}>
        {body && <Markdown className="textBlock__body">{body}</Markdown>}
        {hasRocket && this.renderRocket()}
      </div>
    )
  }
}

export default withLazyRef(TextBlock)
